import React from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import ResetFiltersButton from '../../../../components/FilterBar/ResetFiltersButton';
import {
  WaterSiteType,
  WaterSiteTypePicker,
} from '../../../../components/WaterSite/WaterSiteTypePicker';
import { getStringSearchPlaceholder } from '../../../../helpers/search';
import { searchFields } from './WaterSites';

export type WaterSiteFilters = {
  type?: WaterSiteType;
  stringSearch?: string | undefined;
};

export const defaultFilters: WaterSiteFilters = {
  stringSearch: undefined,
};

type FilterBarWaterSitesProps = FilterBarProps<WaterSiteFilters>;

const FilterBarWaterSites: React.FC<FilterBarWaterSitesProps> = (props) => {
  const { filters, setFilters, selectedId } = props;

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(searchFields)}
          autoFocus={isBrowser && !selectedId}
          width={300}
          name="stringSearch"
          value={filters.stringSearch === undefined ? '' : filters.stringSearch}
          onChange={onChange}
        />
        <WaterSiteTypePicker
          isClearable
          onChange={(value) => {
            setFilters({
              ...filters,
              type: value,
            });
          }}
          value={filters.type}
        />
      </Flex>
      <Flex variant="filterBar.right">
        <ResetFiltersButton setFilters={setFilters} />
      </Flex>
    </Flex>
  );
};

FilterBarWaterSites.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarWaterSites;
